import { render, staticRenderFns } from "./TbbHeader.vue?vue&type=template&id=39cbde62&scoped=true"
import script from "./TbbHeader.vue?vue&type=script&lang=js"
export * from "./TbbHeader.vue?vue&type=script&lang=js"
import style0 from "./TbbHeader.vue?vue&type=style&index=0&id=39cbde62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cbde62",
  null
  
)

export default component.exports